import { useEffect, useState } from "react";
import { SidebarWidgetStyled } from "./styled";
import systemRoutes from "navigations/systemRoutes";
import { useNavigate, useLocation } from "react-router-dom";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

// จำสถานะย่อ/ขยายไว้ข้ามการ refresh
const COLLAPSED_KEY = "sidebar_collapsed";

const SidebarWidget = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [_active, _setActive] = useState();
  const [_collapsed, _setCollapsed] = useState(
    () => localStorage.getItem(COLLAPSED_KEY) === "true"
  );

  useEffect(() => {
    if (location) {
      const splitPathname = location.pathname.split("/");
      _setActive(splitPathname[2]);
    }
  }, [location]);

  const _handleClickMenu = (e) => {
    navigate(e.children ? e.children[0].path : e.path);
  };

  const _handleToggle = () => {
    const next = !_collapsed;
    _setCollapsed(next);
    localStorage.setItem(COLLAPSED_KEY, next ? "true" : "false");
  };

  return (
    <SidebarWidgetStyled className={_collapsed ? "collapsed" : ""}>
      <div className="s_logo_sec">
        <img
          className="sidebar_logo"
          alt="MiSUMi logo"
          src="/assets/images/logos/logo.png"
        />
      </div>
      <button
        type="button"
        className="s_toggle_btn"
        onClick={_handleToggle}
        title={_collapsed ? "ขยายเมนู" : "ย่อเมนู"}
        aria-label={_collapsed ? "ขยายเมนู" : "ย่อเมนู"}
      >
        {_collapsed ? <MdChevronRight size={20} /> : <MdChevronLeft size={20} />}
      </button>
      <ul className="s_menu_sec">
        {systemRoutes &&
          systemRoutes.map((e, i) => (
            <li
              key={i}
              className={`s_menu_item ${_active === e.key ? "active" : ""}`}
              onClick={() => _handleClickMenu(e)}
            >
              <span className="s_menu_icon">
                {e.icon && e.icon(_active === e.key ? true : false)}
              </span>
              <span className="s_menu_label">{e.name}</span>
            </li>
          ))}
      </ul>
    </SidebarWidgetStyled>
  );
};

export default SidebarWidget;
